import React, { useEffect } from 'react';
import styled from 'styled-components';

import ReactTooltip from 'react-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import {borderRadius9} from '../../global/Variables.js';


const StyledNewProduct = styled.div`
    width: 398px;
    max-height: 300px;
    border-radius: ${borderRadius9};
    justify-items: center;
    -webkit-transform: unset;
    -ms-transform: unset;
    -webkit-transform: unset;
    -ms-transform: unset;
    transform: unset;
    min-width: unset;
    padding-left: 13px;
    float: none;
    margin-left: 50px;
    left: 0;
    margin-top: 50px;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    display: inline-table;
    position: relative;
    padding-bottom: 0px;
    background: white;
    overflow: visible;
    text-align: center;
    padding-top:40px;
    padding-bottom:40px;
    padding-right:20px;
    padding-left:20px;
    
    border:1px solid transparent;
    transition: all 0.3s ease;
    
 
    &:hover{
        cursor:pointer !important;
      //  border:1px solid #3D55D7;
        //background:#D9D9D9;

       // ackground: #D9D9D9; */
     filter: brightness(0.9);
        
        
    }
    
    
    &.addNew{
        background: var(--black-20, #CCC);
    }

 

    &:nth-child(3n + 1) {
        margin-left: 0px;
    }
    .productHeader {
        position: relative;
        -webkit-transition: all 0.3s ease;
        transition: all 0.3s ease;
        height: 50px;

        span {
            color: var(--black-60, #666);
            text-align: center;
            /* Product Box/Info */
            font-family: "Nunito Sans";
            font-size: 14px;
            font-style: normal;
            font-weight: 300;
            line-height: normal;
        }
        h2{
            color: #000;
            text-align: center;
            font-family: "Nunito Sans";
            font-size: 24px !important;
            font-style: normal;
            font-weight: 400 !important;
            line-height: normal;
        }
    }
    .productThumbnail {
        overflow: hidden;
        margin-top:30px;
        padding-top: 15px;
        padding-bottom: 15px;
        height: 200px !important;
        width: 100%;
        display: block;
        position: relative;
        img{
            height:100%;
        }
        &.isPackshot{
            margin-top:0 !important;
        }
        &.isPackshots{
            path{
                fill:#999 !important;
            }
        }
    }
    .productThumbnail img {
        width: auto;
        max-width: unset;
        max-height: 90% !important;
        float: none;
        left: 50%;
        position: absolute;
        
        -webkit-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        transform: translateX(-50%);
    }

    &.coming_soon{
        color:gray !important;
        background:#e5e5e5;
        cursor:not-allowed !important;
        &:hover{
            cursor:not-allowed !important;
            background:#e5e5e5 !important;
            filter: brightness(1) !important;
        }
    }
    
    .coming_soon_box{
        position: absolute;
        top: 5%;
        left: 64%;
        -ms-transform: rotate(-80deg) translateX(-50%);
        transform: rotate(-45deg) translateX(-50%);
        width: 100%;
        height: 100%;
        h3{
            font-size:36pt;
            color:#3D55D7;
        }
    }
    
    @media (max-width: 1400px){
        width: 30%;
    }
    @media (max-width: 1199px){
        width: 29%;
    }
    @media (max-width: 991px){
        width: 46% !important;

        &:nth-child(3n) {
            margin-left: 0px;
        }
        &:nth-child(3n + 1) {
            margin-left: 50px;
        }
        &:first-child{
            margin-left: 0;
        }
        
    }
    
    @media (max-width:767px){
        width: 45%;
        .productHeader{
          //  height: 200px;
        }
    }

    @media (max-width:600px){
        width: 90%;
        .productHeader{
          //  height: 100px;
        }
        margin-left:0 !important;
      //  margin:auto auto;
        float:none;
    }

    &.isPackshots{
        width:300px !important;
        max-width:300px !important;
        overflow: hidden;
        margin-left:40px;
        background: var(--black-60, #666) !important;
        color:white !important;
        display: inline-block;

        &:nth-child(3n + 1) {
            margin-left: 0px;
        }
        
        
        h2{
            color: white !important;
        }
        .packshotDots{
            margin-bottom:15px;
            margin-top:30px;
            >div{
                width:30%;
                display:inline-block;
min-width:60px;
                .description{
                    color: var(--black-20, #CCC);
                    text-align: center;
                    font-family: "Nunito Sans";
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 300;
                    line-height: normal;
                }
                .noPackshots{
                    margin-top:30px;
                    margin-bottom:30px;
                    color: var(--black-20, #CCC);
                    display:block;
                    /* Status/Text */
                    font-family: "Nunito Sans";
                    font-size: 10px;
                    font-style: normal;
                    font-weight: 300;
                    line-height: normal;
                }
                
            }
        }
  
        .packshotRenderStat{
            margin-top:0;
            margin-bottom:15px;
            color: var(--black-20, #CCC);
            display:block;
            /* Status/Text */
            font-family: "Nunito Sans";
            font-size: 10px;
            font-style: normal;
            font-weight: 300;
            line-height: normal;
        }
        .packshotDescription{
            color: var(--black-20, #CCC);
            text-align: center;

            /* Product Box/Info */
            font-family: "Nunito Sans";
            font-size: 14px;
            font-style: normal;
            font-weight: 300;
            line-height: normal;
        }
        .dot{
            width:9px;
            height:9px;
            border-radius:50px;
            background:#ccc;
            display:inline-block;
            margin-right:5px;
            &.green{

                background:#009E00;
            }

        }
        min-height:475px;
        &.addNew{
            background:#000 !important;
        }

        @media (max-width: 1400px){
            width: 30%;
        }
        @media (max-width: 1199px){
            width: 29%;
        }
        @media (max-width: 991px){
            width: 46% !important;

            &:nth-child(3n) {
                margin-left: 0px;
            }
            &:nth-child(3n + 1) {
                margin-left: 40px;
            }
            &:nth-child(4n + 1) {
                margin-left: 0px;
            }
            &:nth-child(5n + 1) {
                margin-left: 40px;
            }
            &:first-child{
                margin-left: 0;
            }

        }

        @media (max-width:767px){
            width:100% !important;

            margin-left: 0  !important;

            .productThumbnail{
                height: 400px !important;
                
                >svg{
                    margin-top:80px !important;
                }
            }
        }


    }
    
`;

export default function NewProduct({
    props: any,
    clickEvent,
                                       getRenderStatusMessage,
    isPackshots,
    type,
    name,
    description,
    thumnail,
    coming_soon,
    uuid,
    running_renders,
    completed_renders
}) {


    let showSupport = () => {
        window.Intercom("show");
    };
    function capitalize(s) {
        return s[0].toUpperCase() + s.slice(1);
    }

    useEffect(() => {
        ReactTooltip.rebuild();
    }, []);

    return (
        <>
            <StyledNewProduct
                className={`${coming_soon ? "coming_soon" : ""} ${type=== "AddNew" ? "addNew" : ""}  ${isPackshots ? "isPackshots" : ""}`}
                data-productid={uuid}
                data-intercom-target="New product box"
                id={"newProductBox"+uuid}
                data-closeintercombreak={"true"}
                onClick={clickEvent &&!coming_soon  ? ()=> clickEvent(uuid) : null}
            >

                {type !== "AddNew"
                ?
                    <>
                        <div className={` productHeader`}>

                            <h2 className={'mb-3'}>{name}</h2>

                            {!isPackshots ?
                                <span>{description}</span>
                                : null}

                        </div>


                        <div className={isPackshots ? ` isPackshot productThumbnail` :  ` productThumbnail`}>
                            {thumnail ? (
                                <img src={thumnail} className={``} />
                            ) : (
                                <img src={'/images/thumb_obalero.png'} />
                            )}
                        </div>

                        {isPackshots ?
                            <div>

                                <div className={"packshotDots"}>
                                    <div className={'noPackshots'}>
                                        <span className={completed_renders && completed_renders.low > 0 ? 'dot green' : 'dot'}></span>
                                   <span className={"description"}>Low</span>
                                    </div>
                                    <div className={'noPackshots'}>
                                        <span className={completed_renders && completed_renders.medium > 0 ? 'dot green' : 'dot'}></span>
                                        <span  className={"description"}>Mid</span>
                                    </div>

                                    <div className={'noPackshots'}>
                                        <span className={completed_renders && completed_renders.high > 0 ? 'dot green' : 'dot'}></span>
                                     <span  className={"description"}>High</span>
                                    </div>
                                </div>


                                {/*{renderedPackshots > 0 ?*/}
                                {/*    <span className={'noPackshots'}>*/}
                                {/*    <span className={renderedPackshots > 0 ? 'dot green' : 'dot'}></span>*/}
                                {/*        {renderedPackshots} Packshots*/}
                                {/*</span> :*/}
                                {/*    <span className={'noPackshots'}>*/}
                                {/*    <span className={renderedPackshots > 0 ? 'dot green' : 'dot'}></span>*/}
                                {/*     No packshots*/}
                                {/*</span>*/}
                                {/*}*/}

                                {running_renders ?
                                    <>
                                        {running_renders.map((runningRender, index) => {

                                            if(runningRender.status !== 'error'){
                                                return (
                                                    <span
                                                        className={'packshotRenderStat'}>  <img style={{
                                                        filter: 'brightness(0) saturate(100%) invert(50%) sepia(300%) saturate(500%) hue-rotate(90deg) brightness(100%) contrast(101%)',
                                                        height: '15px',
                                                        position: 'relative',
                                                        marginRight: '5px',
                                                    }}
                                                                                                src={'/logoAnimate.svg'} /> {capitalize(runningRender.quality) + '-res / ' + getRenderStatusMessage("low",runningRender.status)}
                                                  </span>
                                                );
                                            } else {
                                                return (
                                                    <span
                                                        className={'packshotRenderStat'}>  <img style={{
                                                        filter: 'brightness(0) saturate(100%) invert(50%) sepia(300%) saturate(500%) hue-rotate(315deg) brightness(100%) contrast(101%)',
                                                        height: '15px',
                                                        position: 'relative',
                                                        marginRight: '5px',
                                                    }}
                                                                                                src={'/logoAnimate.svg'} /> {capitalize(runningRender.quality) + '-res / ' + getRenderStatusMessage("low",runningRender.status)}
                                                  </span>
                                                );
                                            }

                                        })}
                                    </> :
                                    null
                                }

                                <span className={'packshotDescription'}>{description}</span>
                            </div>
                            : null}

                        <ReactTooltip />

                        {coming_soon ?
                            <div className={'coming_soon_box'}>
                                <h3>Coming soon</h3>
                            </div>
                            : null}
                    </>
                    :
                    <div onClick={() => showSupport()}      data-closeintercombreak={"true"}>

                        {isPackshots ?
                            <div className={` productHeader`} data-closeintercombreak={"true"}>


                                <h2 className={'mb-3'} data-closeintercombreak={"true"}>Missing a view?</h2>
                            </div>
                            :
                            <div className={` productHeader`} data-closeintercombreak={"true"}>


                                <h2 className={'mb-3'} data-closeintercombreak={"true"}>Something new?</h2>
                                <span data-closeintercombreak={"true"}>Can't find your product on this list?
                            Don't worry and stay relaxed.
                            We’ll create one for you.</span>
                            </div>
                        }


                        <div className={isPackshots ? `isPackshots productThumbnail` : "productThumbnail"} data-closeintercombreak={"true"}>
                            <FontAwesomeIcon icon={faCirclePlus} data-closeintercombreak={"true"}
                                             style={isPackshots ? { fontSize: "128px", color: "white", marginTop: "0" } : { fontSize: "128px", color: "white", marginTop: "45px" }} />
                        </div>

                        {isPackshots ?
                            <div className={` productHeader`} data-closeintercombreak={"true"}>

                                <span data-closeintercombreak={"true"}>Need a different view of this product?
                                            Don't worry and stay relaxed.
                                            We’ll create a one fitting your needs.</span>
                            </div>
                            :
                           null
                        }


                    </div>
                }


            </StyledNewProduct>
        </>
    );
}
